import { z } from "zod";
export const AccountantSchema = z.object({
    companyId: z.string(),
    companyName: z.string(),
    email: z.string().email(),
    hasBeenActivated: z.boolean(),
});
export const CreateAccountantPayloadSchema = z.object({
    companyName: z.string(),
    email: z.string().email(),
});
export const UpdateAccountantPayloadSchema = z.object({
    companyName: z.string(),
});
//# sourceMappingURL=accountant.types.js.map